export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12834.64833a64.jpg";